import type {PublicMethodUtils} from '@wix/document-services-types'
import type {PublicModuleDeclaration} from '../../documentServicesInitialisation'
import type {NamedRangesPublicAPI} from '@wix/document-services-public-types'

export default function (publicMethodUtils: PublicMethodUtils): PublicModuleDeclaration<NamedRangesPublicAPI> {
    const {
        extensionPublicAPI: {getter, dataManipulation}
    } = publicMethodUtils

    return {
        methods: {
            site: {
                namedRanges: {
                    get: getter('site.namedRanges.get'),
                    list: getter('site.namedRanges.list'),
                    add: dataManipulation('site.namedRanges.add', {
                        getReturnValueMethodPath: 'site.namedRanges.getNewItemPointer'
                    }),
                    update: dataManipulation('site.namedRanges.update'),
                    remove: dataManipulation('site.namedRanges.remove')
                }
            }
        }
    }
}
